// Registro dos módulos (ordem = ordem da navegação). Rotas e itens da Sidebar derivam daqui.
import { authzModule } from './authz';
import { documentsModule } from './documents';
import { facilitiesModule } from './facilities';
import { identityModule } from './identity';
import { notificationsModule } from './notifications';
import { peopleModule } from './people';
import { reportsModule } from './reports';
import { schedulingModule } from './scheduling';
import { sharedMailboxesModule } from './shared-mailboxes';
import { studiesModule } from './studies';
import { suppliersModule } from './suppliers';
import { tenancyModule } from './tenancy';
import type { ModuleDefinition } from './types';
import { workflowModule } from './workflow';

export const MODULES: readonly ModuleDefinition[] = [
  sharedMailboxesModule,
  studiesModule,
  peopleModule,
  facilitiesModule,
  suppliersModule,
  tenancyModule,
  identityModule,
  authzModule,
  documentsModule,
  schedulingModule,
  workflowModule,
  notificationsModule,
  reportsModule,
];

export type { ModuleDefinition, ModuleKey, ModuleLabelKey, ModuleScopeEntry } from './types';
